import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetUnseenSavedSearchMatchesService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Config} config
   * @param {Fetcher} deps.repository
   * @param {Service} deps.getCurrentUserService
   * @param {ValueObjectFactory} deps.unseenSavedSearchMatchesVOFactory
   */
  constructor({config, repository, getCurrentUserService, unseenSavedSearchMatchesVOFactory}) {
    super()

    this._config = config
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._unseenSavedSearchMatchesVOFactory = unseenSavedSearchMatchesVOFactory
    this._DEFAULT_UNREAD_MESSAGES = this._config.get('notifications').DEFAULT_UNREAD_MESSAGES
  }

  /**
   * @return {Promise<UnseenSavedSearchMatchesValueObject>} returns current user unseen saved searches
   * **/

  async execute(alertId) {
    const userEntity = await this._getCurrentUserService.execute()

    if (!userEntity)
      return this._unseenSavedSearchMatchesVOFactory({
        matchCounters: this._DEFAULT_UNREAD_MESSAGES
      })

    const userId = userEntity.getId()

    const [error, userMatchCounters] = await this._repository.getUnseenSavedSearchMatches({
      userId,
      alertId
    })

    if (error)
      return this._unseenSavedSearchMatchesVOFactory({
        matchCounters: this._DEFAULT_UNREAD_MESSAGES
      })

    return userMatchCounters
  }
}
